import kebabCase from 'lodash-es/kebabCase'
import React from 'react'

import * as S from './styled'
import type { ArticleListProps } from './types'

export const ArticleList = ({ items }: ArticleListProps) => (
  <S.Container>
    {items.map((item) => (
      <S.ItemContainer key={kebabCase(item.title)}>
        <S.ItemInner href={item.url} target="_blank">
          <S.ItemMain>
            <S.Title>{item.title}</S.Title>
            <S.Footer>
              <S.TimeToRead>
                <time>{item.timeToRead}</time>
                <span>↗</span>
              </S.TimeToRead>
            </S.Footer>
          </S.ItemMain>
          <S.ItemImageContainer>
            <S.ItemImage src={item.imageSrc} />
          </S.ItemImageContainer>
        </S.ItemInner>
      </S.ItemContainer>
    ))}
  </S.Container>
)
